export const contactFormId = 'contact-form'

// Gatsby's initial hash scroll can run before the banner height has settled.
export const alignContactForm = (focus = true) => {
    let frame = window.requestAnimationFrame(() => {
        frame = window.requestAnimationFrame(() => {
            if (window.location.hash !== `#${contactFormId}`) return

            const form = document.getElementById(contactFormId)
            if (!form) return

            // Focus the section without opening the mobile keyboard.
            if (focus) form.focus({ preventScroll: true })
            form.scrollIntoView({ block: 'start', behavior: 'auto' })
        })
    })

    return () => window.cancelAnimationFrame(frame)
}
